
export function ProfileAvatar({ short, size = 36 }: { short: string; size?: number }) {
  return (
    <span
      className="flex shrink-0 items-center justify-center rounded-xl bg-brand font-medium text-black"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.32) }}
      aria-hidden
    >
      {short}
    </span>
  );
}

export function plural(count: number, one: string, few: string, many: string) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}
